//react
import { useEffect, useState } from "react";

//router
import { useLocation } from "react-router-dom";

//components
import { NavigationBar, Page } from "./styles";

const MenuDesktop = () => {
  const [pathName, setPathName] = useState(window.location.pathname);

  const { pathname } = useLocation();

  useEffect(() => {
    setPathName(pathname);
  }, [pathname]);
  return pathname === "/" || pathname === "/about_us" ? (
    <NavigationBar>
      <Page to="/" className={pathName === "/" ? "login" : ""}>
        Login
      </Page>
      <Page
        to="/about_us"
        className={pathName === "/about_us" ? "about_us" : ""}
      >
        Sobre nós
      </Page>
    </NavigationBar>
  ) : (
    <NavigationBar>
      <Page
        to="/unitHabits"
        className={pathName === "/unitHabits" ? "unitHabits" : ""}
      >
        UH's
      </Page>
      <Page to="/guests" className={pathName === "/guests" ? "guests" : ""}>
        Hóspedes
      </Page>
      <Page
        to="/products_services"
        className={pathName === "/products_services" ? "products_services" : ""}
      >
        Produtos e Serviços
      </Page>
      <Page
        to="/colaborators"
        className={pathName === "/colaborators" ? "colaborators" : ""}
      >
        Colab
      </Page>
      <Page
        to="/dashboard"
        className={pathName === "/dashboard" ? "dashboard" : ""}
      >
        Home
      </Page>
    </NavigationBar>
  );
};

export default MenuDesktop;
